import { useEffect, useState } from 'react';

import clsxm from '@/lib/clsxm';

import ResponsiveHygraphImage, {
  ResponsiveHygraphImageProps,
} from '@/components/responsive-hygraph-image';
import Row from '@/components/row';
import Section from '@/components/section';
import Separator from '@/components/separator';
import SearchJobsByDiscipline from '@/components/static/search-jobs-by-discipline';
import Typography, { TypographyColor } from '@/components/typography';

import COMMON_CLASS_NAMES from '@/constants/common-class-names';
import { RowLayout } from '@/enums/row-layout';
import { Spacing } from '@/enums/spacing';

export type HeroWithSearchProps = {
  caption?: string;
  title?: string;
  backgroundImages?: ResponsiveHygraphImageProps[] | undefined;
};

export const HeroWithSearch = ({
  caption,
  title,
  backgroundImages,
}: HeroWithSearchProps) => {
  const [backgroundImage, setBackgroundImage] = useState<
    ResponsiveHygraphImageProps | undefined
  >();

  useEffect(() => {
    if (!backgroundImages || backgroundImages.length === 0) {
      return;
    }

    setBackgroundImage(
      backgroundImages[Math.floor(Math.random() * backgroundImages.length)]
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Section>
      {backgroundImage && (
        <div
          className={clsxm(
            'absolute left-1/2 z-10 h-[calc(100%-6rem)] w-full -translate-x-1/2 overflow-hidden md:h-full',
            COMMON_CLASS_NAMES.mainContentContainerWidth
          )}
        >
          <ResponsiveHygraphImage
            {...backgroundImage}
            imgClassName='object-cover sm:rounded-0 md:rounded-2xl'
            fill
          />
        </div>
      )}
      <Row
        className='relative z-20 mb-0'
        layout={RowLayout.MAX_WIDTH_CENTER_WIDE}
      >
        <div className='flex w-full flex-col items-center'>
          <Separator spacing={Spacing.LARGE} />
          {caption && (
            <Typography.Body2
              color={TypographyColor.PRIMARY_CONTRAST}
              className='pb-0 text-center'
            >
              {caption}
            </Typography.Body2>
          )}
          {title && (
            <Typography.Heading1
              color={TypographyColor.PRIMARY_CONTRAST}
              className='mt-4 text-center md:mt-2'
            >
              {title}
            </Typography.Heading1>
          )}

          <Separator spacing={Spacing.MEDIUM} />
          <div className='w-full'>
            <SearchJobsByDiscipline className='lg:max-w-full' />
            <span className='hidden md:block'>
              <Separator spacing={Spacing.LARGE} />
            </span>
          </div>
        </div>
      </Row>
    </Section>
  );
};
export default HeroWithSearch;
